import { render, staticRenderFns } from "./Mappings.vue?vue&type=template&id=392f70a6&scoped=true&"
import script from "./Mappings.vue?vue&type=script&lang=js&"
export * from "./Mappings.vue?vue&type=script&lang=js&"
import style0 from "./Mappings.vue?vue&type=style&index=0&id=392f70a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f70a6",
  null
  
)

export default component.exports